<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div>
    <page-header class="py-4 pb-6">
      {{ $t('datevSetting') }}
      <template #action>
        <div class="d-flex">
          <v-spacer />
          <template v-if="$vuetify.breakpoint.mdAndUp">
            <v-btn
              color="amber lighten-4 black--text"
              elevation="0"
              @click="saveConfirm"
            >
              <v-icon left>
                mdi-content-save-outline
              </v-icon>
              {{ $t('save') }}
            </v-btn>
          </template>
          <template v-else>
            <fab-button
              fab-bottom-val="90px"
              fab-fixed
              fab-right
              @click-event="saveConfirm"
            />
          </template>
        </div>
      </template>
    </page-header>
    <loading-provider :loading="loading">
      <div>
        <v-tabs
          v-model="tab"
          background-color="transparent"
          color="black"
          style="background: transparent"
        >
          <v-tab>{{ $t('basicSetting') }}</v-tab>
          <v-tab>{{ $t('CashUsage') }}</v-tab>
          <v-tab>{{ $t('PaymentProcedure') }}</v-tab>
          <v-tab>{{ $t('Source') }}</v-tab>
          <v-tabs-items
            v-model="tab"
            class="mt-4"
            style="background: transparent"
          >
            <v-tab-item>
              <div class="pa-2">
                <template v-for="(item,index) in notKontoForms ">
                  <div
                    :key="index"
                  >
                    <div class="text-overline">
                      {{ item.fieldName }}
                    </div>
                    <v-text-field
                      v-model="item.value"
                      :placeholder="item.description"
                      :rules="item.isRequired === '1' ? [() => !!item.value || 'This field should not be empty'] : []"
                      dense
                      hide-details
                      outlined
                    />
                    <div
                      class="text--secondary py-1"
                      style="font-size: 12px"
                    >
                      {{ item.description }}
                    </div>
                  </div>
                </template>
              </div>
            </v-tab-item>
            <v-tab-item>
              <v-container>
                <v-row>
                  <v-col cols="6">
                    <div class="font-weight-bold text-h4 mt-2">
                      {{ $t('PosCashIncome') }}
                    </div>
                    <template v-for="(item,index) in leftCashUse ">
                      <div
                        :key="index"
                      >
                        <div class="text-overline">
                          {{ item.name }}
                        </div>
                        <div class="d-flex">
                          <v-text-field
                            v-model="item.account"
                            :placeholder="item.name"
                            append-outer-icon="mdi-delete"
                            dense
                            hide-details
                            outlined
                            type="number"
                            @click:append-outer="deleteUseOfCash(item)"
                          />
                        </div>
                      </div>
                    </template>
                    <div class="d-flex align-center justify-center">
                      <v-btn
                        class="mt-4"
                        color="#25A18E"
                        elevation="0"
                        large
                        width="100%"
                        @click="openAddDialog(1)"
                      >
                        {{ $t('AddPrivateDeposit') }}
                      </v-btn>
                    </div>
                  </v-col>
                  <v-col cols="6">
                    <div class="font-weight-bold text-h4 mt-2">
                      {{ $t('PosCashOut') }}
                    </div>
                    <template v-for="(item,index) in rightCashUse ">
                      <div
                        :key="index"
                      >
                        <div class="text-overline">
                          {{ item.name }}
                        </div>
                        <div class="d-flex">
                          <v-text-field
                            v-model="item.account"
                            :placeholder="item.name"
                            append-outer-icon="mdi-delete"
                            dense
                            hide-details
                            outlined
                            type="number"
                            @click:append-outer="deleteUseOfCash(item)"
                          />
                        </div>
                      </div>
                    </template>
                    <div class="d-flex align-center justify-center">
                      <v-btn
                        class="mt-4"
                        color="#25A18E"
                        elevation="0"
                        large
                        width="100%"
                        @click="openAddDialog(2)"
                      >
                        {{ $t('AddPrivatePayout') }}
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>
            <v-tab-item>
              <div class="pa-2 d-flex flex-column">
                <div class="font-weight-bold text-h4">
                  {{ $t('PaymentMethods') }}
                </div>
                <template v-for="(item,index) in paymentList ">
                  <div
                    :key="index"
                  >
                    <div class="text-overline">
                      {{ item._langsname }}
                    </div>
                    <v-text-field
                      v-model="item.datevAccount"
                      :placeholder="item._langsname"
                      dense
                      hide-details
                      outlined
                      type="number"
                    />
                  </div>
                </template>
              </div>
            </v-tab-item>
            <v-tab-item>
              <div class="pa-2 d-flex flex-column">
                <div class="font-weight-bold text-h4">
                  {{ $t('Source') }}
                </div>
                <template v-for="(item,index) in kontoForms ">
                  <div
                    :key="index"
                  >
                    <div class="text-overline">
                      {{ item.fieldName }}
                    </div>
                    <v-text-field
                      v-model="item.value"
                      :placeholder="item.description"
                      :rules="item.isRequired === '1' ? [() => !!item.value || $i18n.t('EmptyInput')] : []"
                      dense
                      hide-details
                      outlined
                    />
                    <div
                      class="text--secondary py-1"
                      style="font-size: 12px"
                    >
                      {{ item.description }}
                    </div>
                  </div>
                </template>
              </div>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </div>
    </loading-provider>
    <v-dialog
      v-model="addCashUse"
      max-width="600px"
      persistent
    >
      <v-card class="pa-4">
        <div class="d-flex">
          <div
            v-if="inOurOut === 1"
            class="text-h3 font-weight-bold"
          >
            {{ $t('CashReceipts') }}
          </div>
          <div
            v-else
            class="text-h3 font-weight-bold"
          >
            {{ $t('CashOut') }}
          </div>
          <v-spacer />
          <div>
            <v-btn
              icon
              @click="addCashUse = false"
            >
              <v-icon large>
                mdi-close
              </v-icon>
            </v-btn>
          </div>
        </div>
        <v-form
          ref="useOfCash"
          v-model="valid"
          lazy-validation
        >
          <div class="mt-2 mb-1">
            {{ $t('Designation') }}
          </div>
          <v-text-field
            v-model="cashUseName"
            dense
            hide-details
            outlined
            required
          />
          <div class="mb-1">
            {{ $t('Account') }}
          </div>
          <v-text-field
            v-model="cashUseCode"
            dense
            hide-details
            outlined
            required
          />
        </v-form>
        <div class="d-flex">
          <v-spacer />
          <v-btn
            v-if="inOurOut === 1"
            class="primary  mt-4 lighten-2"
            elevation="0"
            style="border-radius: 36px"
            @click="save(1)"
          >
            {{ $t('confirm') }}
          </v-btn>
          <v-btn
            v-else
            class="primary  mt-4 lighten-2"
            elevation="0"
            style="border-radius: 36px"
            @click="save(2)"
          >
            {{ $t('confirm') }}
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import FabButton from '@/views/AadenPages/components/FabButton/FabButton.vue'
import PageHeader from '@/views/widget/typography/PageHeader.vue'
import {
  addUseOfCash,
  deleteUseOfCash,
  editUseOfCash,
  getCashUseful,
  showAllDatevSettings,
  updateDatevSettings
} from '@/model/dataLayer/service/otherService'
import { showSuccessMessage, sureToDelete } from '@/model/utils/utils'
import i18n from '@/i18n'
import Utils from '@/model/utils/IkUtils/Utils'
import Payment from '@/model/dataLayer/api/common/Payment'
import LoadingProvider from '@/views/widget/LoadingProvider'

export default {
  components: {
    LoadingProvider,
    FabButton,
    PageHeader
  },
  data: function () {
    return ({
      tab: null,
      inOurOut: 1,
      cashUseType: null,
      cashUseName: null,
      cashUseCode: null,
      items: [
        {
          key: 1,
          value: '收入到kasse'
        }, {
          key: 2,
          value: '从kasse支出'
        }
      ],
      addCashUse: false,
      cashUseful: [],
      paymentList: null,
      datevForm: null,
      edit: false,
      loading: false,
      valid: true
    })
  },
  computed: {
    leftCashUse () {
      return this.cashUseful.filter(it => it.lrMark === '1')
    },
    rightCashUse () {
      return this.cashUseful.filter(it => it.lrMark === '2')
    },
    kontoForms () {
      return this.datevForm?.filter(
        it => it.fieldName.toLowerCase() === 'konto 7' || it.fieldName.toLowerCase() === 'konto 19' || it.fieldName.toLowerCase() === 'konto 0') ?? []
    },
    notKontoForms () {
      return this.datevForm?.filter(it => !it.fieldName.toLowerCase().includes('konto')) ?? []
    }
  },

  watch: {
    addCashUse (val) {
      if (!val) {
        this.cashUseType = ''
        this.cashUseName = ''
        this.cashUseCode = ''
      }
    }
  },
  async mounted () {
    await this.initialize()
  },
  methods: {
    openAddDialog (item) {
      this.inOurOut = item
      this.addCashUse = true
    },
    async save (item) {
      await addUseOfCash({
        account: this.cashUseCode,
        name: this.cashUseName,
        lrMark: item
      })
      await this.initialize()
      this.addCashUse = false
      showSuccessMessage(i18n.t('AddSuccess'))
    },
    async deleteUseOfCash (item) {
      await sureToDelete(async () => {
        await deleteUseOfCash(item.id)
      })
      showSuccessMessage(i18n.t('delete_success'))
      await this.initialize()
    },
    async saveConfirm () {
      let hasEmptyItem = false

      if (this.datevForm.find(_ => _.isRequired === '1' && _.value === '')) {
        hasEmptyItem = true
        Utils.showError(i18n.t('EmptyInput'))
        return false
      }
      if (!hasEmptyItem) {
        updateDatevSettings(this.datevForm).then(() => {
          Utils.toast(this.$t('submit_success'))
        })
      }
      for (const item of this.paymentList) {
        await Payment.edit(item)
      }
      for (const item of this.leftCashUse) {
        await editUseOfCash(item, item.id)
      }
      for (const item of this.rightCashUse) {
        await editUseOfCash(item, item.id)
      }
    },

    async initialize () {
      this.loading = true
      this.datevForm = await showAllDatevSettings()
      const payments = await Payment.getList()
      const positivePayments = payments.filter(it => it.id > 0).filter(it => it.id !== 9 && it.id !== 4)
      const negativePayments = payments.filter(it => it.id < 0)
      this.paymentList = positivePayments.concat(negativePayments)
      this.cashUseful = (await getCashUseful()).filter(it => !it.deletedAt)
      this.loading = false
    }

  }
}
</script>

<style scoped>

</style>
